import { render } from "./TipTap.vue?vue&type=template&id=33717a9f"
import script from "./TipTap.vue?vue&type=script&lang=js"
export * from "./TipTap.vue?vue&type=script&lang=js"

import "./TipTap.vue?vue&type=style&index=0&id=33717a9f&lang=scss"
import "./TipTap.vue?vue&type=style&index=1&id=33717a9f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__